module.exports = __webpack_public_path__ + "img/share-with-practice.7166f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/patient/share-with-practice.png
// module id = 599
// module chunks = 5